import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import { get } from 'lodash';


import './sidebar.style.css';
import logo_dashboard from './dashboard_icon_menu.svg';
import logo_pipedetail from './pipeline_icon.svg';
import logo_nrw_calculation from './nrw_calculation_icon.svg';
import logo_map from './map1.svg';

import { setToggleSidebar } from '../../../redux/general/action';
import routes from '../../../routes'

// isToggleSideBarOpen
class SideBar extends React.Component {
    constructor(props) {
        super(props);
        this.classSideBar = 'sidebar'
        this.classMenu = 'name-menu'
        if (!this.props.isToggleSideBarOpen) {
            this.classSideBar = 'sidebar sidebar_small'
            this.classMenu = 'name-menu name-menu_display-none'
        }
        this.state = {
            isOpen: true,
            pathName: ''
        }
    }

    componentDidMount() {
        // console.log('this.props',  this.props)
        // var sidebar = document.getElementsByClassName("sidebar");
        // var liMenus = document.getElementsByClassName("li-menu");
        // for (var i = 0; i < liMenus.length; i++) {
        //     liMenus[i].addEventListener("click", function () {
        //         var current = document.getElementsByClassName("active");
        //         current[0].className = current[0].className.replace(" active", "");
        //         this.className += " active";
        //     });
        // }

        const mainContent = document.querySelector('.main-content');
        if (this.props.isToggleSideBarOpen) {
            mainContent.classList.remove('main-content_large');
        } else {
            mainContent.classList.add('main-content_large');
        }
    }

    toggle = () => {
        this.props.setToggleSidebar(!this.props.isToggleSideBarOpen)
    }


    // componentWillUpdate(nextProps, nextState) {
    //     if (nextProps.isToggleSideBarOpen) {
    //         this.classSideBar = 'sidebar'
    //         this.classMenu = 'name-menu'
    //     } else {
    //         this.classSideBar = 'sidebar sidebar_small'
    //         this.classMenu = 'name-menu name-menu_display-none'
    //     }
    // }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.isToggleSideBarOpen) {
            this.classSideBar = 'sidebar'
            this.classMenu = 'name-menu'
        } else {
            this.classSideBar = 'sidebar sidebar_small'
            this.classMenu = 'name-menu name-menu_display-none'
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        const mainContent = document.querySelector('.main-content');
        if (this.props.isToggleSideBarOpen) {
            mainContent.classList.remove('main-content_large');
        } else {
            mainContent.classList.add('main-content_large');
        }
        // if (prevProps.isToggleSideBarOpen !== this.props.isToggleSideBarOpen) {
        //     // TODO con lung do
        //     const mainContent = document.querySelector('.main-content');
        //     mainContent.classList.toggle('main-content_large');
        // }
    }

    render() {
        const tamp = 'text-decoration-none';
        const li_menu = 'li-menu';
        const slug = this.props.currentPath; //lay tu react router
        // console.log('slug: ', slug);
        return (
            <div className={this.classSideBar}>
                <a href="#" className="button-sidebar w-button text-decoration-none" onClick={this.toggle}>M</a>
                <ul>
                    {/* <li className={li_menu + (slug===routes.home ? ' active' : '')}>
                        <Link to={routes.home} className="text-decoration-none">
                            <img src={logo_dashboard} alt="" className="icon-menu" width='32px'/><p className={this.classMenu}>Dashboards</p>
                        </Link>
                    </li> */}
                    <li className={li_menu + (slug === routes.pipelinedetail ? ' active' : '')}>
                        <Link to="/pipelinedetail" className="text-decoration-none">
                            <img src={logo_pipedetail} alt="" className="icon-menu" width='32px' /><p className={this.classMenu}>Pipe Details</p>
                        </Link>
                    </li>
                    <li className={li_menu + (slug === routes.nrwcalculate ? ' active' : '')}>
                        <Link to="/nrwcalculate" className="text-decoration-none">
                            <img src={logo_nrw_calculation} alt="" className="icon-menu" width='32px' /><p className={this.classMenu}>NRW Calculation</p>
                        </Link>
                    </li>
                    <li className={li_menu + (slug === (routes.map || routes.realLoss || routes.waterBalanceTable) ? ' active' : '')} >
                        <Link to="/map" className="text-decoration-none">
                            <img src={logo_map} alt="" className="icon-menu" width='32px' /><p className={this.classMenu}>Map</p>
                        </Link>
                    </li>
                </ul>
            </div>
        )
    }
}

// export default SideBar

const mapStateToProps = state => ({
    isToggleSideBarOpen: get(state, 'GeneralStore.isToggleSideBarOpen')
})

const mapDispatchToProps = dispatch => {
    return {
        setToggleSidebar: isOpen => {
            dispatch(setToggleSidebar(isOpen))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)
